<template>
  <div class="header">
    <el-row>
      <el-col :span="24">
        <div class="bg-dark clear">
          <div class='logo fl' href='http://mnbinggui.mengniu.com.cn/web/index.htm'>智能卧式柜监测云平台</div>
          <div class='fr'>
            <!--<div class="warning fl">欢迎使用</div>-->
            <!--<div class="warning fl"><i class="el-icon-warning"></i></div>
            <div class="warning fl"><i class="el-icon-warning"></i></div>
            <div class="warning fl"><i class="el-icon-warning"></i></div>-->
            <!--<div class="warning fl">退出 <i class="el-icon-remove"></i></div>-->
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'cHeader',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>
<style scoped>
  .bg-dark {
    background: rgba(0, 0, 0,0.25);
    padding: 10px 20px;
    line-height: 24px;
    color: #fff;
    font-size: 12px;
    border-bottom: 1px solid #60676e;
  }
  .bg-dark .logo {
    font-size: 14px;
  }
  .warning {
    padding: 0 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/cHeader.vue